export function compareValues(a: unknown, b: unknown, dir: 'asc' | 'desc') {
  const aNorm = normalizeSortValue(a, dir);
  const bNorm = normalizeSortValue(b, dir);

  if (aNorm < bNorm) return dir === 'asc' ? -1 : 1;
  if (aNorm > bNorm) return dir === 'asc' ? 1 : -1;
  return 0;
}

function normalizeSortValue(value: unknown, dir: 'asc' | 'desc') {
  if (value == null) {
    return dir === 'asc' ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
  }
  if (typeof value === 'string') {
    return value.toLocaleLowerCase('pt-BR');
  }
  if (typeof value === 'boolean') {
    return Number(value);
  }
  return value;
}

export function paginateRows<T>(rows: T[], page: number, pageSize: number) {
  const start = Math.max(0, (page - 1) * pageSize);
  return rows.slice(start, start + pageSize);
}
